import React, {useState} from "react";
import {EditorState, convertToRaw,  convertFromRaw} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const toolbar = {
    options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'history'],
    inline: {
        options: ['bold', 'italic', 'underline']
    },
    blockType: {
        inDropdown: true,
        options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote']
    },
    fontSize: {
        options: [10, 12, 14, 16, 18, 24, 30, 36, 48]
    },
    list: {
        options: ['unordered', 'ordered']
    },
    textAlign: {
        options: ['left', 'center', 'right', 'justify']
    }
};


const TextEditor = ({name, value, error, label, onChange, onBlur, columns, inline}) => {
    const className = `${inline ? 'd-flex flex-wrap ' : ''}col-12${columns?.md ? ' col-md-' + columns.md + '' : ''}`;

    // Initialize editor state with content
    const [editorState, setEditorState] = useState(
        value !== '' ? EditorState.createWithContent(convertFromRaw(JSON.parse(value))) : EditorState.createEmpty()
    );

    // Handler for editor state change
    const onChangeHandler = (state) => {
        setEditorState(state);
        const updatedValue = JSON.stringify(convertToRaw(state.getCurrentContent()));
        onChange({
            target: {
                name,
                value: updatedValue
            }
        });
    };

    // Handle blur
    const onBlurHandler = () => {
        onBlur({
            target: {
                name,
            }
        });
    };

    return (
        <div className={className}>
            {label &&
                <label className={`form-label opacity-75${inline ? ' mb-0 py-2 col-12 col-md-4' : ''}`}
                       htmlFor={name}>
                    {label}
                </label>
            }
            <Editor
                editorState={editorState}
                toolbar={toolbar}
                wrapperClassName={`font-muktamahee${inline ? ' col' : ''}`}
                editorClassName="form-control"
                onEditorStateChange={onChangeHandler}
                onBlur={onBlurHandler}
            />
            {error && <div className={`form-text text-start text-danger w-100${inline && label ? ' offset-4' : ''}`}>{error}</div>}
        </div>
    );
};
export default TextEditor;
